// MODULE: Handle email address changing on admin
// Only loads on /account
window.mythos_email_change = window.mythos_email_change || {};
mythos_email_change = (function() {
  const shopUrl = 'https://www.pyramid-display.co.uk/'
  var storefrontAccessToken = '9bf93ef0a3b9a859e8b19a14204984d3';
  var accessToken = '';

  function _clickOpenChangeEmailForm(event) {
    event.preventDefault();
    document.getElementById('myt-open-change-email-form').style.display = 'none';
    document.getElementById('myt-change-email-form-wrapper').style.display = 'block';
  }

  function _clickCloseChangeEmailForm(event) {
    event.preventDefault();
    _closeChangeEmailForm();
  }

  function _closeChangeEmailForm() {
    document.getElementById('myt-change-email-form-wrapper').style.display = 'none';
    document.getElementById('myt-open-change-email-form').style.display = 'block';
  }

  async function _submitChangeEmailForm(event) {
    event.preventDefault();
    _clearMessages();

    var currentEmailAddress = document.getElementById('current_email').value;
    var newEmailAddress = document.getElementById('new_email').value;
    var accountPassword = document.getElementById('password').value;

    if(newEmailAddress.length < 1 || accountPassword.length < 1) {
      _setError('Please enter your new email address and your current account password.');
      return false;
    }

    try {
      // get access token
      const query1 = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }`;

      const params = {
        query: query1,
        variables: { input: { email: currentEmailAddress, password: accountPassword }}
      }
      const optionsQuery1 = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken
        },
        body: JSON.stringify(params)
      };

      await fetch(shopUrl + `/api/2021-07/graphql.json`, optionsQuery1)
          .then(res => res.json())
          .then(response => {
            if(response.data.customerAccessTokenCreate.customerUserErrors.length > 0) {
              throw('Unable to change your email address. Please confirm your password and try again');
            } else {
              accessToken = response.data.customerAccessTokenCreate.customerAccessToken.accessToken;
            }

          })

      // change password
      const query2 = `mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
          customer {
            id
          }
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }`;
      const params2 = {
        query: query2,
        variables: {
          "customerAccessToken": accessToken,
          "customer": {
            "email": newEmailAddress
          }
        }
      };
      const optionsQuery2 = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken
        },
        body: JSON.stringify(params2)
      };

      await fetch(shopUrl + `/api/2021-07/graphql.json`, optionsQuery2)
          .then(res => res.json())
          .then(response => {
            if(response.data.customerUpdate.customerUserErrors.length > 0) {
              throw(response.data.customerUpdate.customerUserErrors[0].message);
            }
          });

      document.getElementById('myt-email-address').innerHTML = newEmailAddress;
      document.querySelector('#myt-change-email-form-validation-message .good').innerHTML = 'Email has been updated';
      _closeChangeEmailForm();

    } catch(err) {
      _setError(err);
    }
  }

  function _setError(message) {
    _clearMessages();
    var $changeEmailValidationMessage = document.querySelector('#myt-change-email-form-validation-message .bad');
    $changeEmailValidationMessage.innerHTML = message;
    return true;
  }

  function _clearMessages() {
    document.querySelector('#myt-change-email-form-validation-message .bad').innerHTML = '';
    document.querySelector('#myt-change-email-form-validation-message .good').innerHTML = '';
  }

  return {
    init: function() {
      document.addEventListener("DOMContentLoaded", function() {
        if(document.getElementById("myt-open-change-email-form")) {
          // click to open the change email form
          const changeEmailButton = document.getElementById("myt-open-change-email-form");
          changeEmailButton.addEventListener("click", _clickOpenChangeEmailForm, false);

          // click cancel on the form
          const cancelChangeEmailButton = document.getElementById("change-email-form-cancel");
          cancelChangeEmailButton.addEventListener("click", _clickCloseChangeEmailForm, false);

          // click submit on the form
          const submitChangeEmailButton = document.getElementById("change-email-form-submit");
          submitChangeEmailButton.addEventListener("click", _submitChangeEmailForm, false);

        }

        // only if on the admin page
        if(document.querySelector('body.edit-tags-php')) {
          // if they change the category

        }
      });
    }
  };
})();
mythos_email_change.init();


// MODULE: Adjust display price on product page based on the computed product price from Bold PRE
// Only loads on product page
window.mythos_wholesale_pricing = window.mythos_wholesale_pricing || {};
mythos_wholesale_pricing = (function() {
  // compare Bold PRE pricing with what is displayed and correct
  function _setCorrectPriceBasedOnDiscounts() {
    var api = window.BOLD.pre;
    var variantId = document.querySelector("select[name='id']").value;
    if (!variantId) return 'Variant not found';
    var cart = api.getCart();

    cart.items.forEach($item => {
      if($item.variant_id == variantId) {
        var formattedPrice = api.formatAmount($item.price);
        var $price = document.querySelector('.product-details .price.price-field');

        if($price.innerHTML != formattedPrice) {
          $price.innerHTML = formattedPrice;
        }
      }
    });
  }

  return {
    init: function() {
      if(document.querySelector('.product-details .price.price-field')) {
        window.BOLD.pre.ready().then((api) => {
          // observe for changes to pricing once pre loaded
          const div = document.querySelector("h2.offers").children[0];
          observer = new MutationObserver(function(mutationsList, observer) {
            _setCorrectPriceBasedOnDiscounts();
          });
          observer.observe(div, {characterData: true, childList: true, attributes: false});

          // pre updates, e.g. add to cart
          api.events.on("update", () => {
            _setCorrectPriceBasedOnDiscounts();
          });

        });
      }


    }
  };
})();
//mythos_wholesale_pricing.init();


// MODULE: Add a redirect link to any product page, handles form redirection on login page
// Only loads on product page or admin page
window.mythos_login_redirect = window.mythos_login_redirect || {};
mythos_login_redirect = (function() {
  function _callNTimes(func, num, delay) {
    if (!num) return;
    func();
    setTimeout(function() { _callNTimes(func, num - 1, delay); }, delay);
  }

  function _addRedirectToLoginLinks() {
    // Current URL
    var pathName = window.location.pathname;

    // Find all login links on the page
    var linkList = document.querySelectorAll('a[href="/account/login"'); // returns NodeList
    var linkArray = [...linkList]; // converts NodeList to Array

    linkArray.forEach($link => {
      // Make sure it doesn't already have a querystring
      if(!$link.href.match('/[?]/')) {
        // Return to current page
        $link.href = $link.href + '?return_to=' + pathName
      }
    });
  }

  // Append a return_to hidden element to login form
  function _addReturnToLoginForm() {
    var redirectPath = _getReturnToUrl();

    $form = document.querySelector('form#customer_login');

    $redirect = document.createElement('input');
    $redirect.setAttribute('name', 'return_to');
    $redirect.setAttribute('type', 'hidden');
    $redirect.value = redirectPath;
    $form.appendChild($redirect);
  }

  // Fetch and sanitize ReturnTo URL from querytring
  function _getReturnToUrl() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    var returnToUnsanitized = params.return_to;

    const validChars = 'a-zA-Z0-9\/\-';
    var regex = new RegExp('[^' + validChars + ']', 'g');

    return returnToUnsanitized.replace(regex, '');
  }

  return {
    init: function() {
      document.addEventListener("DOMContentLoaded", function() {
        _callNTimes(_addRedirectToLoginLinks, 10, 1000);

        //if(window.location.href.match(/\/account\/login/g)) {
        if(document.querySelector('form#customer_login')) {
          _addReturnToLoginForm();
        }

      });
    }
  };
})();
mythos_login_redirect.init();


window.mythos_gempages_pricing = window.mythos_gempages_pricing || {};
mythos_gempages_pricing = (function() {

  function _format_pennies_to_dollars_GBP(amount_in_pennies) {
    return (amount_in_pennies / 100).toLocaleString("en-gb", {style:"currency", currency:"GBP"});
  }

  function _hide_pricing_if_not_logged_in() {
    // code to do a pre-insert
    const insertBefore = (el, htmlString) =>
        el.insertAdjacentHTML('beforebegin', htmlString);

    // only logged-in users can see pricing
    if(typeof mythos_user_logged_in === "undefined") { return; }
    if(mythos_user_logged_in) { return; }

    const pricingCartButtons = document.querySelectorAll('.gf_product-prices, ' +
        '.module-wrap[data-icon="gpicon-product-quantity"], ' +
        '.module-wrap[data-icon="gpicon-product-cartbutton"], ' +
        '.module-wrap[data-label="(P) Cart Button"]');
    var pricingCartButtonsArray = [...pricingCartButtons]; // converts NodeList to Array
    for (var i = 0, len = pricingCartButtonsArray.length; i < len; i++) {
      pricingCartButtonsArray[i].style.display = 'none';
    }

    // as this function may run multiple times, clear out existing buttons
    // section that includes price and will hold our table
    const loginButtons = document.querySelectorAll('.mythos-login-button');
    const loginButtonsArray = [...loginButtons]; // converts NodeList to Array
    loginButtonsArray.forEach($eachLoginButton => {
      $eachLoginButton.remove();
    })

    const loginButton = '<a class="mythos-login-button btn auto-width" href="/account/login"><span>Log in to View Pricing</span></a>';
    const addToCartbuttons = document.querySelectorAll('.module-wrap[data-label="(P) Cart Button"]');
    const addToCartbuttonsArray = [...addToCartbuttons];
    for (var i = 0, len = addToCartbuttonsArray.length; i < len; i++) {
      insertBefore(addToCartbuttonsArray[i], loginButton);
    }

    return;
  }

  async function _create_pricing_tables(productIdToUpdate='') {
    // code to do a pre-insert
    const insertBefore = (el, htmlString) =>
        el.insertAdjacentHTML('beforebegin', htmlString);

    // hide pricing conditionally
    _hide_pricing_if_not_logged_in();

    // only logged-in users can see pricing
    if(typeof mythos_user_logged_in === "undefined") { return; }
    if(!mythos_user_logged_in) { return; }

    if(productIdToUpdate == '') {
      var productNodeList = document.querySelectorAll('.module[data-current-variant]'); // returns NodeList
    } else {
      var productNodeList = document.querySelectorAll('.module[data-current-variant]'); // returns NodeList
    }

    var productArray = [...productNodeList]; // converts NodeList to Array

    for (var i = 0, len = productArray.length; i < len; i++) {
      let refreshPricing = true

      // overall wrapper for this entire product section
      const thisProduct = productArray[i];
      // currently-selected variant
      const thisVariantId = thisProduct.getAttribute('data-current-variant');
      // product ID
      const thisProductInput = thisProduct.querySelector('input[name="id"]');
      const thisProductId = thisProductInput.getAttribute('data-productid');
      // the variant for which our current pricing table applies
      const variantIdForCurrentPricingTableElement = thisProduct.querySelector('table.pricing-table');

      if(variantIdForCurrentPricingTableElement) {
        const variantIdForCurrentPricingTable = variantIdForCurrentPricingTableElement.getAttribute('data-variant-id');

        // we already have a table for this variant
        if(thisVariantId == variantIdForCurrentPricingTable) {
          refreshPricing = false
        }
      }

      if(refreshPricing) {
        // product JSON is supplied by Gempages. Feed that to Bold.
        let thisProductJSONTag = thisProduct.querySelector('.product-json');
        let thisProductJSON = JSON.parse(thisProductJSONTag.innerHTML);

        let productPriceTiers = [];

        window.BOLD.pre.addProductJson(thisProductJSON)
            .then((product) => {
              let variantDetails = window.BOLD.pre.getProductByVariantId(thisVariantId);
              try {
                variantDetails.variants.forEach(thisVariantToCheck => {
                  if (thisVariantToCheck.id == thisVariantId) {
                    // This is custom-adjusted price for a 1 qty. Add as a pricing tier and change big price display
                    productPriceTiers[1] = thisVariantToCheck.price;
                    thisProduct.querySelector('.gf_product-price').setAttribute('data-price', (thisVariantToCheck.price / 100));
                    thisProduct.querySelector('.gf_product-price').innerHTML = _format_pennies_to_dollars_GBP(thisVariantToCheck.price);

                    if (typeof thisVariantToCheck.qty_breaks === 'object') {
                      thisVariantToCheck.qty_breaks.forEach(thisQuantityBreak => {
                        productPriceTiers[thisQuantityBreak.qty] = thisQuantityBreak.price;
                      })
                    }
                  }
                })
              } catch(err){ }

              // now build table
              let table = `<table class='pricing-table' data-variant-id='${thisVariantId}'><thead><tr><th><strong>Qty</strong></th><th><strong>Price</strong></th></tr></thead><tbody>`;

              productPriceTiers.forEach((value, index, self) => {
                let dollars = _format_pennies_to_dollars_GBP(value);
                table = table + '<tr><td>' + index + '</td><td>' + dollars + '</td></tr>';
              })

              table = table + '</tbody></table>';

              // section that includes price and will hold our table
              let pricingTables = thisProduct.querySelectorAll('table.pricing-table');
              let pricingTablesArray = [...pricingTables]; // converts NodeList to Array
              pricingTablesArray.forEach($eachPricingTable => {
                $eachPricingTable.remove();
              })

              let thisQuantityChooser = thisProduct.querySelector('.module-wrap[data-label="(P) Quantity');
              insertBefore(thisQuantityChooser, table);

              // mark as updated
              thisProduct.setAttribute('data-variant-mythos-pricing-set',thisVariantId);

            });
      }
    }

    return true;
  }

  return {
    init: function() {
      _hide_pricing_if_not_logged_in();

      window.BOLD.pre.ready().then((api) => {
        _hide_pricing_if_not_logged_in();
        _create_pricing_tables().then((response) => {
          // add in mutation observers once pricing is added the first time
          const productInputs = document.querySelectorAll('.module[data-current-variant]');
          const productInputsArray = [...productInputs]; // converts NodeList to Array
          productInputsArray.forEach($input => {
            const observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") {
                  const observed = mutation.target.closest('.module[data-current-variant]');
                  const current_variant = observed.getAttribute('data-current-variant');
                  const variant_we_already_set_pricing_for = observed.getAttribute('data-variant-mythos-pricing-set');

                  if(variant_we_already_set_pricing_for) {
                    const observedProductForm = mutation.target.querySelector('form.AddToCartForm ');

                    if(observedProductForm) {
                      const productId = observedProductForm.getAttribute('data-productid');
                      const variant_we_already_observed_changing = observed.getAttribute('data-variant-mythos-change-observed');

                      if(variant_we_already_set_pricing_for != '' && current_variant != variant_we_already_set_pricing_for && current_variant != variant_we_already_observed_changing) {
                        try {
                          const observedEditable = document.querySelector('[data-current-variant="'+current_variant+'"]')
                          observedEditable.setAttribute('data-variant-mythos-change-observed',current_variant);
                        } catch (error) {
                          //console.log('error is ',error)
                        }

                        _create_pricing_tables(productId);
                      }
                    }
                  }
                }
              });
            });
            observer.observe($input, {
              attributes: true, childList: false, characterData: false
            });
          });
        })

        api.events.on("update", () => {
          _create_pricing_tables();
        });
      });

      return;
    }
  };
})();
mythos_gempages_pricing.init();